import {
  Button,
  CollapseWithLabel,
  ComboBox,
  Datepicker,
  InputMaskField,
  Radio,
  TextInput,
  Toggler,
} from '@components';
import {
  BeneficiarioRCMDocs,
  BeneficiarioRCMInitialValues,
  BeneficiarioRCMSchema,
} from '@schemas';
import { parentesco as p } from '@utils';
import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  getRequerimentosPeritos,
  criarRascunhoRequerimento,
  adicionarItemRascunhoRequerimento,
  atualizarItemRascunhoRequerimento,
  excluirItemRascunhoRequerimento,
  concluirEnvioRequerimento,
} from '../../../../store/requerimentos/thunks';
import { ModalUpload } from './components/ModalUpload';
import { validaUpload } from './utils/validaUpload';
import { rulesSituationParentsBeneficiarios } from '../../../../common/schemas/requerimentos/utils/rulesByKey';

const Anexos = ({ parentesco = '', disabled, reset, cpf, acao, situacao }) => {
  const anexosArray = BeneficiarioRCMDocs[parentesco];
  const anexoDeObitoAoExcluir = BeneficiarioRCMDocs[acao];
  const anexoInvalidez = BeneficiarioRCMDocs[situacao];
  const beneficiarios = useSelector(
    (state) => state.requerimentos.formularioLista
  );

  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      <ModalUpload modalIsOpen={modalIsOpen} setModalIsOpen={setModalIsOpen} />
      {acao === 'Excluir' &&
        (anexoDeObitoAoExcluir || []).map((anexo) => (
          <div className="row" key={anexo.name}>
            <div className="col-md-12 col-lg-6">
              <Field
                className="mb-3"
                name={anexo.name}
                type="file"
                label={anexo.label}
                accept="image/*,.pdf"
              >
                {({ form }) => {
                  const itemAtual = beneficiarios.find((dp) => dp.cpf === cpf);
                  const anexoAtual = itemAtual?.anexos.find(
                    (anx) => anx.name === anexo.name
                  );

                  return (
                    <TextInput
                      key={reset ? 'reset' : ''}
                      className="mb-3"
                      name={anexo.name}
                      type="file"
                      multiple
                      label={anexo.label}
                      accept="image/*,.pdf"
                      onChange={(e) => {
                        return validaUpload({
                          anexo,
                          e,
                          form,
                          setModalIsOpen,
                        });
                      }}
                      disabled={disabled}
                      defaultFile={anexoAtual}
                    />
                  );
                }}
              </Field>
            </div>
          </div>
        ))}
      {acao !== 'Excluir' &&
        (anexosArray || []).map((anexo) => (
          <div className="row" key={anexo.name}>
            <div className="col-md-12 col-lg-6">
              <Field
                className="mb-3"
                name={anexo.name}
                type="file"
                label={anexo.label}
                accept="image/*,.pdf"
              >
                {({ form }) => {
                  const itemAtual = beneficiarios.find((dp) => dp.cpf === cpf);
                  const anexoAtual = itemAtual?.anexos.find(
                    (anx) => anx.name === anexo.name
                  );

                  return (
                    <TextInput
                      key={reset ? 'reset' : ''}
                      className="mb-3"
                      name={anexo.name}
                      type="file"
                      multiple
                      label={anexo.label}
                      accept="image/*,.pdf"
                      onChange={(e) => {
                        form.setFieldTouched(anexo.name);
                        form.setFieldValue(
                          anexo.name,
                          e.target.value ? e.currentTarget.files : null
                        );
                      }}
                      disabled={disabled}
                      defaultFile={anexoAtual}
                    />
                  );
                }}
              </Field>
            </div>
          </div>
        ))}
      {(anexoInvalidez || []).map((anexo) => (
        <div className="row" key={anexo.name}>
          <div className="col-md-12 col-lg-6">
            <Field
              className="mb-3"
              name={anexo.name}
              type="file"
              label={anexo.label}
              accept="image/*,.pdf"
            >
              {({ form }) => {
                const itemAtual = beneficiarios.find((dp) => dp.cpf === cpf);
                const anexoAtual = itemAtual?.anexos.find(
                  (anx) => anx.name === anexo.name
                );

                return (
                  <TextInput
                    key={reset ? 'reset' : ''}
                    className="mb-3"
                    name={anexo.name}
                    type="file"
                    multiple
                    label={anexo.label}
                    accept="image/*,.pdf"
                    onChange={(e) => {
                      form.setFieldTouched(anexo.name);
                      form.setFieldValue(
                        anexo.name,
                        e.target.value ? e.currentTarget.files : null
                      );
                    }}
                    disabled={disabled}
                    defaultFile={anexoAtual}
                  />
                );
              }}
            </Field>
          </div>
        </div>
      ))}
      {acao !== 'Excluir' &&
        (BeneficiarioRCMDocs.others || []).map((anexo) => (
          <div className="row" key={anexo.name}>
            <div className="col-md-12 col-lg-6">
              <Field
                className="mb-3"
                name={anexo.name}
                type="file"
                label={anexo.label}
                accept="image/*,.pdf"
              >
                {({ form }) => {
                  const itemAtual = beneficiarios.find((dp) => dp.cpf === cpf);
                  const anexoAtual = itemAtual?.anexos.find(
                    (anx) => anx.name === anexo.name
                  );

                  return (
                    <TextInput
                      key={reset ? 'reset' : ''}
                      className="mb-3"
                      name={anexo.name}
                      type="file"
                      multiple
                      label={anexo.label}
                      accept="image/*,.pdf"
                      onChange={(e) => {
                        form.setFieldTouched(anexo.name);
                        form.setFieldValue(
                          anexo.name,
                          e.target.value ? e.currentTarget.files : null
                        );
                      }}
                      disabled={disabled}
                      defaultFile={anexoAtual}
                    />
                  );
                }}
              </Field>
            </div>
          </div>
        ))}
    </>
  );
};

const CardBeneficiario = ({
  plano,
  nomeBeneficiario,
  cpf,
  nascimento,
  nomeMaeBeneficiario,
  nomePaiBeneficiario,
  parentesco,
  medicoPerito,
  medicoAssistente,
  consentimentoDadosSensiveis,
  anexos,
  acao,

  setDisabled,
}) => {
  const formattedInitialAnexos = anexos.reduce(
    (previousValue, currentValue) => {
      return { ...previousValue, [currentValue.name]: currentValue };
    },
    {}
  );

  const initial = {
    acao,
    plano,
    nomeBeneficiario,
    cpf,
    nascimento,
    nomeMaeBeneficiario,
    nomePaiBeneficiario,
    parentesco,
    medicoPerito,
    medicoAssistente,
    consentimentoDadosSensiveis,
    ...formattedInitialAnexos,
  };

  return (
    <>
      <hr className="mt-32 mt-xs-0 mb-32" />
      <CollapseWithLabel
        label={
          <>
            <strong>Beneficiario: </strong>
            {nomeBeneficiario}
          </>
        }
      >
        <FormikBody type="update" initial={initial} setDisabled={setDisabled} />
      </CollapseWithLabel>
    </>
  );
};

const FormikBody = ({ initial, type, setDisabled }) => {
  const dispatch = useDispatch();
  const isUpdate = type === 'update';
  const [isEditing, setIsEditing] = useState(!isUpdate);
  const [calledReset, setCalledReset] = useState(false);
  const [dynamicSchema, setDynamicSchema] = useState(null);

  const listaPlanos = useSelector(
    (state) => state.user.dadosPessoais.planoPrevidencia
  );
  const showPlano = listaPlanos.length > 1;

  const peritos = useSelector((state) => state.requerimentos.peritos);

  useEffect(() => {
    setDisabled(isEditing);
  }, [isEditing, setDisabled]);

  useEffect(() => {
    dispatch(getRequerimentosPeritos());
  }, [dispatch]);

  useEffect(() => {
    setDynamicSchema(BeneficiarioRCMSchema(listaPlanos));
  }, [listaPlanos]);

  return (
    <>
      <hr className="mt-32 mt-xs-0 mb-32" />
      <Formik
        validateOnMount
        initialValues={initial || BeneficiarioRCMInitialValues}
        validationSchema={dynamicSchema}
        onSubmit={(values, { resetForm }) => {
          setDisabled(false);

          const successMessage = 'Beneficiário adicionado com sucesso';

          if (isUpdate) {
            const nascimento =
              values?.nascimento?.toLocaleDateString('pt') || values.nascimento;

            dispatch(
              atualizarItemRascunhoRequerimento({
                campos: {
                  ...values,
                  nomePaiBeneficiario: values.nomePaiBeneficiario
                    ? values.nomePaiBeneficiario
                    : 'Não informado',
                  nascimento,
                  plano: values.plano || listaPlanos[0]?.name,
                },
                camposAntigos: initial,
                successMessage: successMessage.replace(
                  'adicionado',
                  'atualizado'
                ),
              })
            );

            setIsEditing(false);
          } else {
            dispatch(
              adicionarItemRascunhoRequerimento({
                campos: {
                  ...values,
                  nomePaiBeneficiario: values.nomePaiBeneficiario
                    ? values.nomePaiBeneficiario
                    : 'Não informado',
                  nascimento: values.nascimento
                    ? values.nascimento.toLocaleDateString('pt')
                    : '',
                  plano: values.plano || listaPlanos[0]?.name,
                },
                successMessage,
              })
            );

            resetForm();
            setCalledReset(true);
            setTimeout(() => {
              setCalledReset(false);
            }, 150);
          }
        }}
      >
        {({ handleSubmit, isValid, values, setFieldValue }) => (
          <Form>
            <div className="row">
              <div className="col-md-12 col-lg-6 d-flex gap-2 align-items-baseline">
                <p className="mb-4">Ação:</p>
                <Field
                  className="me-3"
                  name="acao"
                  color="orange"
                  type="radio"
                  label="Incluir/Alterar"
                  component={Radio}
                  value="Incluir/Alterar"
                  disabled={!isEditing}
                />
                <Field
                  type="radio"
                  color="orange"
                  name="acao"
                  label="Excluir"
                  component={Radio}
                  value="Excluir"
                  disabled={!isEditing}
                />
              </div>
            </div>

            {showPlano && (
              <div className="row">
                <div className="col-md-12 col-lg-6">
                  <Field
                    className="mb-3"
                    name="plano"
                    component={ComboBox}
                    options={['Plano A', 'Plano B', 'Taesa', 'Todos'].map(
                      (x) => {
                        return { value: x, label: x };
                      }
                    )}
                    label="Plano"
                    disabled={!isEditing}
                  />
                </div>
              </div>
            )}
            <div className="row mb-3 form-row-flex">
              <div className="form-row-son">
                <Field
                  className="form-row-g-son"
                  name="nomeBeneficiario"
                  component={TextInput}
                  label="Nome completo do (a) Beneficiário"
                  disabled={!isEditing}
                />
              </div>
              {values.acao && values.acao !== 'Excluir' && (
                <div className="form-row-son">
                  <Field
                    className="form-row-g-son"
                    name="cpf"
                    mask="111.111.111-11"
                    inputMode="numeric"
                    component={InputMaskField}
                    label="CPF Beneficiário"
                    disabled={!isEditing}
                  />
                </div>
              )}
            </div>

            {values.acao && values.acao !== 'Excluir' && (
              <div className="row">
                <div className="col-md-12 col-lg-6 mb-lg-32">
                  <Field
                    name="nascimento"
                    component={Datepicker}
                    datePickerClassName="formSize"
                    max={new Date()}
                    className="mb-3"
                    label="Data de Nascimento do Beneficiário"
                    disabled={!isEditing}
                    showYearDropdown
                    yearDropdownItemNumber={100}
                    scrollableYearDropdown
                  />
                </div>
              </div>
            )}

            {values.acao && values.acao !== 'Excluir' && (
              <div className="row mb-3 form-row-flex">
                <div className="form-row-son">
                  <Field
                    className="form-row-g-son"
                    name="nomeMaeBeneficiario"
                    component={TextInput}
                    label="Nome completo da Mãe do Beneficiário"
                    disabled={!isEditing}
                  />
                </div>
                <div className="form-row-son">
                  <Field
                    className="form-row-g-son"
                    name="nomePaiBeneficiario"
                    component={TextInput}
                    label="Nome completo do Pai do Beneficiário"
                    disabled={!isEditing}
                  />
                </div>
              </div>
            )}

            <div className="row">
              <div className="col-md-12 col-lg-6">
                <Field
                  className="mb-3"
                  name="parentesco"
                  component={ComboBox}
                  options={p.options.parentescosBeneficiariosRCM.map((x) => {
                    return { value: x, label: x };
                  })}
                  label="Parentesco/Vínculo"
                  disabled={!isEditing}
                  onChange={() => {
                    setFieldValue('situacaoParentesco', '', false);
                    setFieldValue('medicoPerito', '', false);
                    setFieldValue('Médico Assistente', '', false);
                  }}
                />
              </div>
              {rulesSituationParentsBeneficiarios.includes(
                values.parentesco
              ) && (
                <div className="col-md-12 col-lg-6">
                  <Field
                    className="mb-3"
                    name="situacaoParentesco"
                    component={ComboBox}
                    options={[
                      { value: 'Sem invalidez', label: 'Sem invalidez' },
                      { value: 'Com invalidez', label: 'Com invalidez' },
                    ]}
                    label="Situação"
                    disabled={!isEditing}
                  />
                </div>
              )}
            </div>

            {values.acao !== 'Excluir' &&
              rulesSituationParentsBeneficiarios.includes(values.parentesco) &&
              values.situacaoParentesco === 'Com invalidez' && (
                <div className="row mb-3 form-row-flex">
                  <div className="form-row-son">
                    <Field
                      className="form-row-g-son"
                      name="medicoPerito"
                      component={ComboBox}
                      label="Médico perito"
                      tooltip="O beneficiário deverá submeter-se a uma perícia médica. Escolha o nome de um médico para agendamento da perícia."
                      options={peritos.map((medico) => {
                        return { value: medico.trim(), label: medico.trim() };
                      })}
                      disabled={!isEditing}
                    />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <Field
                      className="form-row-g-son"
                      name="medicoAssistente"
                      component={ComboBox}
                      label="Médico Assistente"
                      tooltip="Na ocasião da perícia, V. Sª poderá se fazer acompanhar de um médico assistente de sua escolha. A Forluz reembolsará os honorários pagos por V. Sª a esse médico até o limite de R$ 570,00. Para ter direito ao reembolso integral, o médico assistente deverá comparecer pessoalmente à perícia, bem como posteriormente para discussão do laudo. O Valor dos honorários do médico assistente, somente será reembolsado caso V. Sª faça opção neste formulário. Levará médico assistente?"
                      options={['Sim', 'Não'].map((value) => {
                        return { value, label: value };
                      })}
                      disabled={!isEditing}
                    />
                  </div>
                </div>
              )}

            {values.acao === 'Excluir' && (
              <div className="row">
                <div className="col-md-12 col-lg-6">
                  <Field
                    className="mb-3"
                    name="aceiteCienciaExclusao"
                    component={Toggler}
                    createTermsField
                    label="Estou ciente de que, caso eu seja Participante Assistido em gozo de benefício vitalício, o(a) beneficiário(a) excluído(a) só poderá ser reinscrito(a) mediante recálculo do benefício, conforme o Regulamento. Reconheço e aceito as consequências dessa decisão. "
                    disabled={!isEditing}
                  />
                </div>
              </div>
            )}

            <div className="row">
              <div className="col-md-12 col-lg-12">
                <Field
                  className="mb-3"
                  name="consentimentoDadosSensiveis"
                  component={Toggler}
                  label="Com base na Lei nº 13.709/2018 (Lei Geral de Proteção de Dados
                  Pessoais), autorizo o tratamento dos meus dados pessoais e
                  dados pessoais sensíveis para fins relacionados ao meu vínculo
                  com a FORLUZ."
                  disabled={!isEditing}
                />
              </div>
            </div>

            <Anexos
              acao={values.acao}
              parentesco={values.parentesco}
              disabled={!isEditing}
              reset={calledReset}
              cpf={values.cpf}
              situacao={values.situacaoParentesco}
            />
            {isEditing ? (
              <>
                <hr className="mt-32 mt-xs-0 mb-32" />
                <div className="row">
                  <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                    <div className="d-block d-md-flex align-items-center">
                      <Button
                        disabled={!isValid}
                        className="ms-0 ms-md-3"
                        onClick={handleSubmit}
                      >
                        {isUpdate ? 'Atualizar' : 'Adicionar'}
                      </Button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <hr className="mt-32 mt-xs-0 mb-32" />
                <div className="row">
                  <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                    <div className="d-block d-md-flex align-items-center">
                      <Button
                        className="ms-0 ms-md-3"
                        onClick={() => {
                          dispatch(
                            excluirItemRascunhoRequerimento({ campos: values })
                          );
                        }}
                      >
                        Eliminar
                      </Button>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                    <div className="d-block d-md-flex align-items-center">
                      <Button
                        className="ms-0 ms-md-3"
                        onClick={() => setIsEditing(true)}
                      >
                        Editar
                      </Button>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};

export const BeneficiarioRCM = ({ title, reference }) => {
  const [disabled, setDisabled] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const beneficiarios = useSelector(
    (state) => state.requerimentos.formularioLista
  );
  const envioLoading = useSelector(
    (state) => state.requerimentos.envio.loading
  );

  useEffect(() => {
    dispatch(criarRascunhoRequerimento(reference));
  }, [dispatch, reference]);

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>

        <FormikBody setDisabled={setDisabled} />
        {beneficiarios.map((beneficiario) => {
          return (
            <CardBeneficiario
              key={beneficiario.nomeBeneficiario}
              {...beneficiario}
              setDisabled={setDisabled}
            />
          );
        })}
        {beneficiarios.length > 0 && (
          <>
            <hr className="mt-32 mt-xs-0 mb-32" />
            <div className="row">
              <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                <div className="d-block d-md-flex align-items-center">
                  <Button
                    disabled={disabled || envioLoading}
                    className="ms-0 ms-md-3"
                    onClick={() => {
                      dispatch(
                        concluirEnvioRequerimento({ formulario: reference })
                      )
                        .unwrap()
                        .then(() => {
                          navigate('/requerimentos/andamento');
                        });
                    }}
                  >
                    Solicitar
                  </Button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
